// Firebase Initialization
// This file initializes Firebase app and messaging
// Location: src/common/utils/firebase/firebase-init.js

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { firebaseConfig, FCM_VAPID_KEY } from './firebase-config';

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Messaging (only in browser environment)
let messaging = null;

if (typeof window !== 'undefined') {
  try {
    const isSecureContext = 
      window.isSecureContext || 
      window.location.protocol === 'https:' || 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1';
    
    if (isSecureContext && 'serviceWorker' in navigator) {
      try {
        messaging = getMessaging(app);
        console.log('✅ Firebase Messaging initialized successfully');
      } catch (messagingError) {
        console.error('❌ Error initializing Firebase messaging:', messagingError);
        messaging = null;
      }
    } else {
      if (!isSecureContext) {
        console.warn('⚠️ Firebase messaging requires HTTPS or localhost. Current protocol:', window.location.protocol);
      } else {
        console.warn('⚠️ Service Worker is not supported, Firebase messaging will not be available');
      }
    }
  } catch (error) {
    console.error('❌ Firebase messaging initialization error:', error);
    messaging = null;
  }
}

export { messaging, getToken, onMessage };

